export const mapDataForClient = (userDetails) => ({
  givenName: userDetails.firstName || '',
  familyName: userDetails.lastName || '',
  email: userDetails.email || '',
  workNumber: userDetails.phoneNumber || '',
  organization: userDetails.organization || '',
});
